<template>
  <div>
    <b-col>
      <SearchCard
        :filterCatch="true"
        :title="$lang.question_title_list"
        :url="url_title"
        :html="false"
        ref="searchCard"
      >
        <template slot="html" slot-scope="{ item }">
          <b-col class="border-bottom my-1 py-2" cols="12">
            <div class="float-left">
              <b-form-checkbox
                v-model="item.checked"
                @change="changeChecked(item)"
                class="m-0"
              >
              </b-form-checkbox>
            </div>
            <b>{{ $lang.azmoonLang.number_question }}</b> : {{ item.id }}
            <span @click="Clipboard(item.title_description)">
              <i
                class="fa fa-clipboard fa-lg icon-clipboard"
                aria-hidden="true"
              ></i>
            </span>
          </b-col>
          <b-col cols="12">
            <div
              class="text-description"
              ref="textQuestion"
              v-html="createPureDom(item.title_description)"
            ></div>
          </b-col>
        </template>
      </SearchCard>
    </b-col>
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import { createPureDom } from "@/shared/utils";
export default {
  props: {
    titles: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SearchCard,
  },
  data() {
    return {
      url_title: this.$config.api_url + this.$config.azmoon.title,
      search: "",
      isCollapse: false,
      addCk: false,
    };
  },
  methods: {
    createPureDom,
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    Clipboard(text) {
      navigator.clipboard.writeText(text);
      this.selectText(this.$refs.textQuestion);
      document.execCommand("copy");
      this.$notify.success(this.$lang.linkCopy);
    },
    changeChecked(data) {
      this.$refs.searchCard.items.map((item) => {
        if (item.id == data.id) item.checked = true;
        else item.checked = false;
      });
      this.$emit("optionSelected", data);
    },
  },
};
</script>

<style scoped>
.remove_value {
  position: absolute;
  top: 10px;
  left: 40px;
  color: #ff000094;
  cursor: pointer;
  z-index: 99;
}

.icon-clipboard {
  position: absolute;
  left: 2%;
  top: 0px;
  cursor: pointer;
}
</style>
